import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { approveBillingRow, fetchBillingList } from './billing.api';
import type { BillingListFilters, BillingModule } from './types';

export const useBillingList = (filters: BillingListFilters) => useQuery({ queryKey: ['billing', 'list', filters], queryFn: () => fetchBillingList(filters) });

export const useApproveBillingRow = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ module, id }: { module: BillingModule; id: string }) => approveBillingRow(module, id),
    onSuccess: () => void client.invalidateQueries({ queryKey: ['billing'] }),
  });
};
